import { ListTagReviewItemsV2, ListTagReviewItemsV2Variables } from './__generated__/ListTagReviewItemsV2'

import { useQuery } from '@apollo/react-hooks'
import { gql } from 'apollo-boost'

const QUERY = gql`
  query ListTagReviewItemsV2($input: ListTagReviewItemsInputV2!) {
    listTagReviewItems: listTagReviewItemsV2(input: $input) {
      items {
        id
        batchId
        entityType
        entityId
        status
        suggestedTags
        acceptedTags
        messageSetId
        messageSetTitle
        categories
        characters
        listingTitle
        listingDescription
        listingIconUrl
        popularityScore
        messageComposition
        rejectionReason
        createdAt
        queuedAt
        processedAt
        error {
          type
          message
        }
      }
    }
  }
`

export const useListTagReviewItems = (variables: ListTagReviewItemsV2Variables) => {
  return useQuery<ListTagReviewItemsV2, ListTagReviewItemsV2Variables>(QUERY, {
    fetchPolicy: 'cache-and-network',
    variables
  })
}
